/**
 * Custom hook to process the dynamic header title for the Mobile App Panel.
 */
import { useMemo } from 'react';
import FactoryService from 'FactoryService';

export const useHeaderTitle = (appName, activePageLayout, selectedSectionId, selectedControlId) => {
    return useMemo(() => {
        if (selectedSectionId) {
            const section = activePageLayout?.find(s => s.id === selectedSectionId);
            return section ? `Section - ${section.name}` : `${appName} - Mobile App`;
        }
        if (selectedControlId) {
            const control = activePageLayout?.flatMap(s => s.controls).find(c => c.id === selectedControlId);
            if (control) {
                const type = FactoryService.factories[control.factoryKey]?.name || 'Control';
                return `${type} - ${control.name}`;
            }
        }
        return `${appName} - Mobile App`;
    }, [appName, activePageLayout, selectedSectionId, selectedControlId]);
};